import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import SelectDeviceTypePageContent from '../PageContent/SelectDeviceTypePageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import { DefaultRegionStorageKey } from '../../../constants/localStorage';

const country = parseInt(localStorage.getItem(DefaultRegionStorageKey)) ?? 1; // Default to 1 if no region is stored in localStorage, this is for inflight onboarding after release.

const SelectDeviceType = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="sm">

            {(country === 1) ?
                <PageTitle
                    heading="Are you using your own tablet, or have you purchased a DateCodeGenie® device?"
                /> :
                <PageTitle
                    heading="Please wait while we build your Portal."
                />}

            <SectionDivider width="70%" />
            <SelectDeviceTypePageContent />
        </HeaderAndBodyLayout>
    );
};

export default SelectDeviceType;